<template>
  <v-container
    fill-height
    fluid
    class="background"
    style="max-height: 100vh;">
    <v-layout
      align-center
      justify-center>
      <v-flex
        xs12
        sm8
        md4>
        <!-- <div class="d-flex align-center">
          <v-avatar color="tranparent" size="100">
            <img src="../assets/img/heron_icon.svg" />
          </v-avatar>
        </div> -->
        <v-card class="elevation-12">
          <v-toolbar color="heron_toolbar">
            <v-avatar
              color="tranparent"
              size="70">
              <img src="../assets/img/energy-control.png" >
            </v-avatar>
            <v-toolbar-title
              class="toolbar_text--text"
            >Energy Control</v-toolbar-title
            >
            <v-spacer />
            <img
              src="../assets/img/heron_icon.svg"
              width="70" >
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="email"
                :error-messages="emailErrors"
                prepend-icon="mdi-account"
                label="E-mail"
                required
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
              />
              <v-text-field
                ref="password"
                v-model="password"
                :error-messages="passwordErrors"
                :rules="[() => !!password || 'This field is required']"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                :type="showPassword ? 'text' : 'password'"
                prepend-icon="mdi-lock"
                label="Κωδικός"
                required
                @input="$v.password.$touch()"
                @blur="$v.password.$touch()"
                @keydown.enter="login"
                @click:append="showPassword = !showPassword"
              />
            </v-form>
          </v-card-text>
          <!-- <v-divider class="mt-5" /> -->
          <v-card-actions>
            <v-btn
              block
              color="general"
              @click="login">Sign in </v-btn>
              <!-- <v-btn block color="heron_success" @click="register">Register </v-btn> -->
          </v-card-actions>
          <v-snackbar
            v-model="snackbar"
            :top="true"
            color="red">
            {{ errorMessages }}
            <v-btn
              dark
              flat
              @click="snackbar = false">
              Close
            </v-btn>
          </v-snackbar>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import Card from './material/Card.vue'

export default {
  components: { Card },
  mixins: [validationMixin],

  validations: {
    email: { required, email },
    password: { required }
  },

  data: function () {
    return {
      email: '',
      password: '',
      errorMessages: '',
      snackbar: false,
      color: 'general',
      showPassword: false,
      emailError: false,
      passwordError: false
    }
  },

  computed: {
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Το e-mail πρέπει να είναι έγκυρο')
      !this.$v.email.required && errors.push('Το e-mail είναι υποχρεωτικό')
      this.emailError = errors.length != 0
      return errors
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Ο κωδικός είναι υποχρεωτικός')
      this.passwordError = errors.length != 0
      return errors
    }
  },

  // Sends action to Vuex that will log you in and redirect to the dash otherwise, error
  methods: {
    login: function () {
      this.$v.$touch()
      if (this.email == '' || this.password == '') {
        this.errorMessages = 'Το e-mail και ο κωδικός είναι υποχρεωτικά'
        this.snackbar = true
      } else if (!this.emailError && !this.passwordError) {
        let email = this.email
        let password = this.password
        this.$store
          .dispatch('login', { email, password })
          .then(() => this.$router.push('/home'))
          .catch((err) => {
            if (err == 400) {
              this.errorMessages = 'Λανθασμένα διαπιστευτήρια σύνδεσης'
              this.snackbar = true
            } else if (err == 404) {
              this.errorMessages = 'Ο χρήστης δεν βρέθηκε'
              this.snackbar = true
            } else if (err == 401) {
              this.errorMessages =
                'Μη εξουσιοδοτημένος χρήστης. Παρακαλώ επικοινωνήστε με το διαχειριστή'
              this.snackbar = true
            } else {
              this.errorMessages =
                'Παρουσιάστηκε σφάλμα κατά την εκτέλεση του αιτήματος'
              this.snackbar = true
            }
          })
      }
    }
    // register: function() {
    //   this.$router.push("/register");
    // },
  },
  metaInfo () {
    return {
      title: 'HERON Energy Control'
    }
  }
}
</script>

<style scoped>
.background {
  background: url("../assets/img/heron_background_new.jpg");
  background-size: cover;
  width: 100%;
  height: 100%;
}
.v-toolbar__title {
  font-size: 1.5rem !important;
}
</style>
